export class InvalidSecurityKeyException implements Error {
  public readonly message: string;
  public readonly  name: string;

  public constructor(message: string) {
    this.message = message;
    this.name = "InvalidSecurityKeyException";
  }
}
